import { useState } from "react";
import { toast } from "sonner";
import { User, UserPlus, X } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import SearchSuggest from "./SearchSuggest";
import { crmErr } from "./helpers";

function NewContact({ tid, testid, onCreated, onCancel }) {
  const api = useApi();
  const [f, setF] = useState({ name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/t/${tid}/crm/contacts`, { name: f.name.trim(), email: f.email.trim(), phone: f.phone.trim() });
      toast.success("Contatto creato"); onCreated({ id: data.id, label: data.name, sub: data.email || "" });
    } catch (e) { toast.error(crmErr(e, errMsg)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 rounded-md border border-dashed p-2.5" data-testid={`${testid}-new-form`}>
      <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Nome e cognome o azienda *" className="h-8 text-sm" data-testid={`${testid}-new-name`} />
      <div className="grid grid-cols-2 gap-2">
        <Input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email" className="h-8 text-sm" data-testid={`${testid}-new-email`} />
        <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Telefono" className="h-8 text-sm" data-testid={`${testid}-new-phone`} /></div>
      <div className="flex justify-end gap-2"><Button size="sm" variant="ghost" onClick={onCancel}>Annulla</Button>
        <Button size="sm" onClick={create} disabled={!f.name.trim() || busy} data-testid={`${testid}-new-save`}>Crea e collega</Button></div>
    </div>);
}

// Required contact of an opportunity: search an existing contact of this space or create a new one inline.
export default function ContactPicker({ tid, value, onChange, testid = "deal-contact" }) {
  const [q, setQ] = useState("");
  const [creating, setCreating] = useState(false);
  if (value) return (
    <div className="flex items-center gap-2 rounded-md border bg-slate-50 px-2.5 py-1.5 text-sm" data-testid={`${testid}-selected`}>
      <User size={14} className="text-slate-400" /><span className="min-w-0 flex-1 truncate">{value.label}{value.sub ? <span className="text-xs text-slate-500"> · {value.sub}</span> : null}</span>
      <button type="button" onClick={() => onChange(null)} aria-label="Cambia contatto" className="rounded p-0.5 hover:bg-slate-200" data-testid={`${testid}-clear`}><X size={14} /></button></div>);
  if (creating) return <NewContact tid={tid} testid={testid} onCreated={(c) => { setCreating(false); onChange(c); }} onCancel={() => setCreating(false)} />;
  return (
    <div className="space-y-1.5">
      <SearchSuggest tid={tid} value={q} onChange={setQ} kinds={["contact"]} onPick={(x) => { onChange({ id: x.id, label: x.label, sub: x.email || x.sub }); setQ(""); }} testid={testid} placeholder="Cerca un contatto (nome, email, azienda)" width="w-full" />
      <button type="button" onClick={() => setCreating(true)} className="inline-flex items-center gap-1 text-xs text-sky-700 hover:underline" data-testid={`${testid}-new`}><UserPlus size={13} />Crea nuovo contatto</button>
    </div>);
}
